import { Component } from '@angular/core';

@Component({
  selector: 'app-plain-layout',
  templateUrl: './plain-layout.component.html',
  styleUrls: ['./plain-layout.component.scss']
})
export class PlainLayoutComponent {

}
